import {
    LayoutDashboard, Radio, Crosshair, Brain, TrendingUp, Trophy, Route,
    Telescope, Film, Youtube, HardDrive, ShieldAlert, FileSearch, BarChart3,
    Medal, Settings, UserCircle, Sparkles, Coins, Gift,
} from "lucide-react";

export const NAV_GROUPS = [
    {
        label: "Overview",
        items: [
            { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "dashboard" },
            { to: "/live", label: "Go Live + Ai Tac Bot", icon: Radio, testid: "live" },
        ],
    },
    {
        label: "Coaching",
        items: [
            { to: "/matches", label: "Matches", icon: Crosshair, testid: "matches" },
            { to: "/coach", label: "AI Coach", icon: Brain, testid: "coach" },
            { to: "/improvement", label: "Improvement Score", icon: TrendingUp, testid: "improvement" },
            { to: "/career", label: "Career Mode", icon: Trophy, testid: "career" },
            { to: "/road-to-pro", label: "Road To Pro", icon: Route, testid: "road-to-pro" },
            { to: "/scout", label: "AI Scout", icon: Telescope, testid: "scout" },
        ],
    },
    {
        label: "Studio & Library",
        items: [
            { to: "/clips", label: "Clips", icon: Film, testid: "clips" },
            { to: "/content", label: "Content Studio", icon: Youtube, testid: "content" },
            { to: "/storage", label: "Storage Center", icon: HardDrive, testid: "storage" },
        ],
    },
    {
        label: "Integrity",
        items: [
            { to: "/integrity", label: "Encounters & Anomaly", icon: ShieldAlert, testid: "integrity" },
            { to: "/evidence", label: "Evidence Packages", icon: FileSearch, testid: "evidence" },
        ],
    },
    {
        label: "Progress",
        items: [
            { to: "/challenges", label: "Challenges & Tournaments", icon: Coins, testid: "challenges" },
            { to: "/referrals", label: "Refer & Earn", icon: Gift, testid: "referrals" },
            { to: "/analytics", label: "Analytics", icon: BarChart3, testid: "analytics" },
            { to: "/achievements", label: "Achievements", icon: Medal, testid: "achievements" },
        ],
    },
];

export const BOTTOM_NAV = [
    { to: "/pricing", label: "Plan Management", icon: Sparkles, testid: "nav-pricing" },
    { to: "/settings", label: "Settings", icon: Settings, testid: "settings" },
    { to: "/profile", label: "Profile", icon: UserCircle, testid: "profile" },
];

export const LOGO_URL = "/whitewater-logo.png";

export const HERO_BG =
    "https://static.prod-images.emergentagent.com/jobs/764fc06b-e2ac-4d2f-bf4f-97333095550d/images/781940080b36dcf237bdcfc1dbef569e03d761a94d0a31e41f0b519df047f7d5.png";

export const SCOUT_ICON =
    "https://static.prod-images.emergentagent.com/jobs/764fc06b-e2ac-4d2f-bf4f-97333095550d/images/47ebefcf4678993fe6b6718e90d02f6820588ef9b37caedd7071d366a7809997.png";
